<template>
  <div class="delivered-page">
    <div class="tabs-header">
      <div v-for="(item,index) in pageTab" :key="index" @click="changeTab(item)" class="tab-item" :class="{'tab-item-active': activeName===item.name}">
        {{item.title}}
      </div>
    </div>
    <div class="tab-detail" v-if="pageTab.length>0">
      <div class="empty"></div>
      <addressComponent :frontData="frontData[this.activeName - 1]" :isExpress="true" :delivered="true"/>
      <div class="list-title">邮寄清单</div>
      <template v-if="frontData[this.activeName - 1].productListRespVOS.length>0">
        <div v-for="(item,index) in frontData[this.activeName - 1].productListRespVOS" :key="index">
          <mailingList :itemData="item"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import addressComponent from '@/components/personalCenter/shippedOrder/addressComponent.vue';
// eslint-disable-next-line
import mailingList from '@/components/personalCenter/shippedOrder/mailingList.vue';

export default {
  components: { addressComponent, mailingList },
  props: {
    frontData: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      activeName: 1,
      pageTab: [],
    };
  },
  mounted() {
    for (let i = 1; i <= this.frontData.length; i += 1) {
      this.pageTab.push({
        title: `包裹${i}`,
        name: i,
      });
    }
  },
  methods: {
    changeTab(val) {
      this.activeName = val.name;
    },
  },
};
</script>

<style scoped lang="scss">
.delivered-page {
  margin: 0 36px;
  padding: 36px 0;

  .tabs-header{
    display: flex;
    width: 100%;
    //margin-top: 200px;
    margin-bottom: 36px;
    overflow-x: scroll;
    &::-webkit-scrollbar {display:none}

    .tab-item {
      min-width: 145px;
      height: 54px;
      margin-top: 10px;
      margin-right: 29px;
      padding: 0 20px;
      font-size: 25px;
      line-height: 54px;
      text-align: center;
      background: #f2f2f2;
      border-radius: 4px;
    }

    .tab-item-active{
      position: relative;
      min-width: 145px;
      height: 54px;
      padding: 0 20px;
      color: $theme_color;
      font-size: 28px;
      line-height: 54px;
      text-align: center;
      background: #FFF0E6;

      &::after{
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: url("../../../../../assets/img/personalCenter/tab_active.png") no-repeat;
        background-position: right bottom;
        background-size: 33px 33px;
        content: '';
      }
    }
  }

  .list-title {
    margin-top: 36px;
    font-weight: bold;
    font-size: 29px;
    line-height: 40px;
  }
}

</style>
